/* eslint-disable */
import React from 'react'
import {Link} from 'react-router-dom'
import http from '../../Component/Interceptor/Interseptor'
import {message} from 'antd'
import {Button, Container, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import Page from '../../Component/Pagination/Pagination'
import HeaderTable from '../BaseComponent/HeaderTable'
import $ from 'jquery'
import cookie from 'react-cookies'
import jMoment from 'moment-jalaali'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import USER_REPORT from '../BaseComponent/USERREPORT'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import Sort from '../Pagination/Sort'
import HeaderGrid from '../Pagination/HeaderGrid'
import Pageing from '../Pagination/pageing'
import Loader from '../loaders/loader'
import Select from 'react-select'

class LocationStatusList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      drivers: [],
      printInfo: [],
      DriversCount: 0,
      modalActivate: false,
      modalBlock: false,
      modalReset: false,
      modalChangeCar: false,
      cars: [],
      modalDelete: false,
      pageNumber: 1,
      pageSize: 10,
      sortBy: 'id_asc',
      sortData: [
        {
          name: 'ردیف',
          value: 'title',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'عنوان',
          value: 'title',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'خانواده تغییرات تحویل',
          value: 'title',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'ترتیب نمایش',
          value: 'sortOrder',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'وضعیت فعال',
          value: 'edit',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'ویرایش',
          value: 'edit',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'حذف',
          value: 'edit',
          sorted: false,
          direction: null,
          sortable: false
        }
      ],
      cartStations: [],
      editModal: false,
      familyChanges: [],
      processId: null
    }
  }

  createFilter = (exportStatus) => {
    let filter = {}
    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.sortBy = this.state.sortBy
    filter.export = exportStatus
    let title = $('#title')
      .val()
      .trim()
    if (title !== '') {
      filter.title = title
    }
    return filter
  }
  getReport = (exportStatus) => {
    let filter = this.createFilter(exportStatus)
    this.setState({
      loading: true
    })
    http
      .get(`deliveryStatus/location/report`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          if (!exportStatus) {
            this.setState({
              cartStations: response.data.object.result,
              countAll: response.data.object.countAll,
              loading: false
            })
          } else {
            this.setState({
              printInfo: response.data.object.result,
              loading: false
            })
          }
        } else {
          this.setState({
            loading: false
          })
        }
      })
      .catch(() => {
        this.setState({
          loading: false
        })
      })
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getReport(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.setState(
        {
          pageNumber: 1
        },
        () => {
          this.getReport(false)
        }
      )
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getReport(false)
    }
  }
  componentDidMount() {
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.filterComponent').slideToggle()
      })

      $('.cancelFilter').click(function() {
        $('.filterComponent').slideUp()
      })
    })
    this.getReport(false)
    this.getFamily()
  }

  getFamily = () => {
    return http
      .get(`process/list`, {})
      .then((res) => {
        if (res.data.error === null) {
          let familyChanges = res.data.object
          familyChanges.forEach((item) => {
            item.value = item.id
            item.label = item.title
          })
          this.setState({
            familyChanges
          })
        }
      })
      .catch((err) => {})
  }

  openActivate = (id, enabled) => {
    if (enabled) {
      http
        .patch(`deliveryStatus/location/${id}/disable`, {})
        .then((response) => {
          if (response.data.error === null) {
            this.getReport(false)
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    } else {
      http
        .patch(`deliveryStatus/location/${id}/enable`, {})
        .then((response) => {
          if (response.data.error === null) {
            this.getReport(false)
          } else {
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  deleteStation = (id, title) => {
    this.setState({
      modalDelete: !this.state.modalDelete,
      id,
      title
    })
  }

  deleteOk = () => {
    let {id} = this.state
    http
      .delete(`deliveryStatus/location/${id}/delete`, {})
      .then((response) => {
        if (response.data.error === null) {
          message.success('جایگاه با موفقیت حذف شد')
          this.getReport(false)
          this.setState({
            modalDelete: !this.state.modalDelete
          })
        } else {
          this.setState({
            modalDelete: !this.state.modalDelete
          })
        }
      })
      .catch(() => {})
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  filter() {
    this.setState(
      {
        pageNumber: 1
      },
      () => {
        this.getReport(false)
      }
    )
  }

  openEdit = (id, title, sortOrder, processId) => {
    let findSelectedFamily = this.state.familyChanges.find((item) => +item.id == +processId)
    this.setState(
      {
        id,
        title,
        sortOrder,
        processId: find ? findSelectedFamily : null
      },
      () => {
        this.setState({
          editModal: true
        })
      }
    )
  }

  editOk = () => {
    let {id, title, sortOrder} = this.state
    let processId =
      !this.state.processId || this.state.processId === null || this.state.processId === ''
        ? ''
        : this.state.processId.id
    if (this.state.title === '' || processId === '') {
      message.error('فیلد های ستاره دار پر شود')
    } else {
      let data = {
        title,
        sortOrder,
        processId
      }
      http
        .put(`deliveryStatus/location/${id}/update`, data, {})
        .then((response) => {
          if (response.data.error === null) {
            message.success(' با موفقیت ویرایش شد')
            this.getReport(false)
            this.setState({
              editModal: !this.state.editModal
            })
          } else {
            this.setState({
              editModal: !this.state.editModal
            })
          }
        })
        .catch(() => {})
    }
  }

  exportExcel = () => {
    let filter = this.createFilter(true)
    http
      .get(`deliveryStatus/location/report`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            excelReport: response.data.object.result
          })
          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })
  }

  getPrintInfo = () => {
    this.getReport(true)
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }
  getPageSize = (pageSize) => {
    this.setState({
      pageSize
    })
  }
  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  changeFamily = (processId) => {
    this.setState({
      processId
    })
  }

  render() {
    let {pageNumber, pageSize, loading} = this.state

    let printCol = ['ردیف', 'نام', 'ترتیب نمایش']
    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="لیست آیتم انتخابی"
              headerColSpan={3}
              reporter={cookie.load('name')}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={1}
              rightColSpan={1}
              centerColSpan={1}
              centerSection={''}
              rightSection={''}
              columns={printCol}
            />

            <tbody>
              {this.state.printInfo.map((item, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{item.title}</td>
                  <td>{item.sortOrder}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="آیتم انتخابی.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'title'}
                field={'title'}
                title={'نام'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'sortOrder'}
                field={'sortOrder'}
                title={'ترتیب نمایش'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>اطلاعات پایه</li>
            <li>مدیریت فرایندها</li>
            <li>آیتم انتخابی</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid
                  getPageSize={this.getPageSize}
                  createLink={'/base/deliveryStatus/addLocationStatus'}
                  enablePageSize
                />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="filterComponent">
              <div className="filterInputs">
                <div className="formComponent">
                  <label>عنوان</label>
                  <input className="form-control" id="title" type="text" />
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="showBaseTable">
              <table className="baseTable">
                <Sort data={this.state.sortData} getSort={this.getSort} />
                <tbody>
                  {this.state.cartStations.map((item, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                      <td>{item.title}</td>
                      <td>{item.processOut !== null && item.processOut.title}</td>
                      <td>{item.sortOrder}</td>
                      <td>
                        <button onClick={() => this.openActivate(item.id, item.enabled)}>
                          {item.enabled ? (
                            <img src={require('../../image/on.svg')} alt="" />
                          ) : (
                            <img src={require('../../image/off.svg')} alt="" />
                          )}
                        </button>
                      </td>
                      <td>
                        <button onClick={() => this.openEdit(item.id, item.title, item.sortOrder, item.processId)}>
                          <img src={require('../../image/editDriver.svg')} alt="" />
                        </button>
                      </td>
                      <td>
                        <button onClick={() => this.deleteStation(item.id, item.title)}>
                          <img src={require('../../image/trash.svg')} alt="" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.countAll}
                />
              </div>
            </div>
          </div>
        </div>
        <Modal isOpen={this.state.modalDelete} toggle={() => this.setState({modalDelete: false})} size="sm">
          <ModalHeader toggle={() => this.setState({modalDelete: false})}>حذف </ModalHeader>
          <ModalBody>
            <p className="titleSm">آیا از حذف {this.state.title} اطمینان دارید ؟؟</p>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.deleteOk}>
              حذف{' '}
            </button>
            <button className="cancelBtnModal" onClick={() => this.setState({modalDelete: false})}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.editModal} toggle={() => this.setState({editModal: false})} size="sm">
          <ModalHeader toggle={() => this.setState({editModal: false})}>ویرایش </ModalHeader>
          <ModalBody>
            <div className="modalForm d-flex flex-column">
              <label>
                خانواده تغییرات <span className="requireFiled">*</span>
              </label>
              <div>
                <Select
                  value={this.state.processId}
                  onChange={this.changeFamily}
                  options={this.state.familyChanges}
                  isMulti={false}
                  isClearable={true}
                  placeholder={''}
                  id="providerId"
                  name="providerId"
                  tabIndex="1"
                />
              </div>
            </div>
            <div className="modalForm">
              <label>
                عنوان
                <span className="requireFiled">*</span>
              </label>
              <input
                className="form-control"
                type="text"
                defaultValue={this.state.title}
                onChange={(e) => this.setState({title: e.target.value})}
              />
            </div>
            <div className="modalForm">
              <label>ترتیب نمایش</label>
              <input
                className="form-control"
                type="number"
                defaultValue={this.state.sortOrder}
                onChange={(e) => this.setState({sortOrder: e.target.value})}
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.editOk}>
              ویرایش{' '}
            </button>
            <button className="cancelBtnModal" onClick={() => this.setState({editModal: false})}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

export default LocationStatusList
